import React from 'react';
import Modal from '../common/Modal';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Выйти?">
      <p className="modal-text">Вы точно хотите выйти из личного кабинета?</p>
      <div className="modal-actions">
        <button className="modal-btn modal-btn--exit" onClick={onConfirm}>
          Выйти
        </button>
        <button className="modal-btn modal-btn--cancel" onClick={onClose}>
          Отменить
        </button>
      </div>
    </Modal>
  );
};

export default LogoutModal;